<mat-spinner *ngIf="loading" style="margin:0 auto;"></mat-spinner>
<div *ngIf="!loading" fxLayout="column" fxLayoutGap="2rem">

    <div *ngIf="breadcrumb.length != 0" fxLayout="row" fxLayoutGap="0.5rem" class="breadcrumb">
        <ng-container *ngFor="let b of breadcrumb; let i = index;">
            <div>
                <a [routerLink]="['/home', b.id]" *ngIf="b.link">{{b.label}}</a>
                <span *ngIf="!b.link">{{b.label}}</span>
            </div>
            <div>
                <span *ngIf="i != breadcrumb.length - 1">|</span>
            </div>
        </ng-container>
    </div>

    <mat-card>

        <div *ngIf="!started || finished" fxLayout="column" fxLayoutGap="2rem" fxLayoutAlign="start center" style="padding:2rem;">
            <ng-container *ngIf="!started">
                <ng-container *ngFor="let moduleContent of moduleContents">
                    <div *ngIf="moduleContent.type == ContentType.TEXT">
                        <h1 style="margin:0">{{moduleContent.value}}</h1>
                    </div>
                    <div *ngIf="moduleContent.type == ContentType.VIDEO" style="position:relative; padding-bottom: 56.25%; width:100%">
                        <iframe [src]="moduleContent.src" style="position:absolute; top:0; left:0; width:100%; height:100%;" frameborder="0" allow="autoplay"></iframe>
                    </div>
                </ng-container>
                <button mat-flat-button color="primary" (click)="start()" *ngIf="pages.length != 0">
                    <span>Next</span>
                </button>
                <button mat-flat-button color="primary" (click)="done()" *ngIf="pages.length == 0">
                    <span>Done</span>
                </button>
            </ng-container>
            <ng-container *ngIf="finished">
                <h1>
                    Thanks!
                </h1>
                <button mat-flat-button color="primary" (click)="done()">
                    Done
                </button>
            </ng-container>
        </div>

        <mat-horizontal-stepper [linear]="moduleType != ModuleType.SLIDESHOW" *ngIf="started && !finished" labelPosition="bottom">

            <mat-step *ngFor="let page of pages; let i = index;" [stepControl]="page.formGroup" [editable]="moduleType == ModuleType.SLIDESHOW" [completed]="page.completed">

                <ng-container *ngFor="let pageContent of page.contents">

                    <div fxLayoutGap="1rem" fxLayout="column">

                        <div style="height: 400px">
                            <app-content-grid-element-display [element]="pageContent"></app-content-grid-element-display>
                        </div>

                    </div>

                </ng-container>

                <div *ngIf="page.contents.length == 0" style="text-align: center; font-size: 75px; color:red">
                    <mat-icon inline>warning</mat-icon>
                </div>

                <div *ngIf="!page.loading">
                    <div fxFlex>
                        <button mat-flat-button color="primary" type="button" matStepperPrevious *ngIf="i != 0 && moduleType == ModuleType.SLIDESHOW">Previous</button>
                    </div>
                    <div>
                        <button mat-flat-button color="primary" type="button" matStepperNext *ngIf="i != pages.length - 1">Next</button>
                        <button mat-flat-button color="primary" type="button" (click)="finished = true" *ngIf="i == pages.length - 1">Next</button>
                    </div>
                </div>

            </mat-step>
        </mat-horizontal-stepper>

    </mat-card>

</div>